"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Providers = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var entity_state_context_1 = require("../components/context/entity-state-context");
var fullscreen_state_context_1 = require("../components/context/fullscreen-state-context");
var filters_state_context_1 = require("../components/context/filters-state-context");
var application_context_1 = require("../components/context/application-context");
var entity_connections_state_context_1 = require("../components/context/entity-connections-state-context");
var entity_network_state_context_1 = require("../components/context/entity-network-state-context");
var application_state_context_1 = require("../components/context/application-state-context");
var entities_context_1 = require("../components/context/entities-context");
var components_1 = require("../components");
var Providers = function (props) {
  var children = props.children,
    application = props.application;
  var theme = application.theme,
    initialState = application.initialState,
    entities = application.entities,
    options = application.options;
  // console.log(application.options);
  var _a = options.componentProps,
    componentProps = _a === void 0 ? {} : _a;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: theme
  }, react_1.default.createElement(entities_context_1.EntitiesProvider, {
    value: entities
  }, react_1.default.createElement(components_1.ComponentPropsProvider, {
    value: componentProps
  }, react_1.default.createElement(application_context_1.ApplicationProvider, {
    value: application
  }, react_1.default.createElement(application_state_context_1.ApplicationStateProvider, null, react_1.default.createElement(fullscreen_state_context_1.FullScreenStateProvider, null, react_1.default.createElement(filters_state_context_1.FiltersStateProvider, {
    initialFiltersState: {}
  }, react_1.default.createElement(entity_connections_state_context_1.EntityConnectionsStateProvider, null, react_1.default.createElement(entity_network_state_context_1.EntityNetworkStateProvider, null, react_1.default.createElement(entity_state_context_1.EntityStateProvider, {
    initialState: initialState
  }, children))))))))));
};
exports.Providers = Providers;
exports.default = exports.Providers;